"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var PostList_1 = __importDefault(require("../../PostList/PostList"));
var myAnnouncementsSlice_1 = require("../../../features/myAnnouncements/myAnnouncementsSlice");
var uri_1 = require("../../../helpers/uri");
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var ConfirmModal_1 = __importDefault(require("../../Modals/ConfirmModal"));
var Routes_1 = require("../../../constants/Routes");
var globalSlice_1 = require("../../../features/global/globalSlice");
var NoResult_1 = __importDefault(require("../../NoResult/NoResult"));
var GeneralSettings_1 = require("../../../constants/GeneralSettings");
var PostLayout_1 = require("../../../types/PostLayout");
var Announcements = function () {
    var dispatch = react_redux_1.useDispatch();
    var history = react_router_dom_1.useHistory();
    var myAnnouncements = react_redux_1.useSelector(myAnnouncementsSlice_1.myAnnouncementsSelector);
    var pageNum = react_1.useState(myAnnouncements ? myAnnouncements.current_page : 1)[0];
    var loading = react_redux_1.useSelector(myAnnouncementsSlice_1.myAnnouncementsLoadingSelector);
    var t = react_i18next_1.useTranslation('common').t;
    var _a = react_1.useState(false), isOpenModal = _a[0], setIsOpenModal = _a[1];
    var _b = react_1.useState(''), selectedAnnouncementId = _b[0], setSelectedAnnouncementId = _b[1];
    var TYPES = {
        icon: 'icon-ic-no-announcements',
        title: "" + t('Account.MY_ANNOUNCEMENTS.EMPTY_MY_ANNOUNCEMENTS'),
        description: "" + t('Account.MY_ANNOUNCEMENTS.WHEN_YOU_ADD_NEW_ANNOUNCEMENT'),
    };
    react_1.useEffect(function () {
        window.scroll(0, 0);
        dispatch(myAnnouncementsSlice_1.getMyAnnouncements(pageNum));
    }, [pageNum]);
    var getMyAnnouncementsList = function (page) {
        dispatch(myAnnouncementsSlice_1.getMyAnnouncements(page));
    };
    var openRemoveAnnouncementModal = function (id) {
        setIsOpenModal(true);
        setSelectedAnnouncementId(id);
    };
    var handleUpdateToTop = function (id, isFavorite) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(myAnnouncementsSlice_1.updateToTop(id, isFavorite))];
                case 1:
                    _a.sent();
                    dispatch(myAnnouncementsSlice_1.getMyAnnouncements(pageNum));
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('MY_ANNOUNCEMENT.UPDATED_TO_TOP_ANNOUNCEMENT_NOTIFICATION.TEXT'),
                        appearance: 'success',
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCancel = function () { return setIsOpenModal(!isOpenModal); };
    var removeAnnouncement = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsOpenModal(false);
                    return [4 /*yield*/, dispatch(myAnnouncementsSlice_1.removeMyAnnouncement(selectedAnnouncementId))];
                case 1:
                    _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('MY_ANNOUNCEMENT.DELETED_ANNOUNCEMENT_NOTIFICATION.TEXT'),
                        appearance: 'info',
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var showStatistic = function (post) {
        history.push({
            pathname: uri_1.createRoute({
                path: Routes_1.Routes.Statistics.path,
                params: {
                    id: post.id,
                },
            }),
        });
    };
    var handleToggleAnnouncementStatus = function (id, status) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/];
    }); }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ConfirmModal_1.default, { open: isOpenModal, cancelButtonTitle: t('MY_ANNOUNCEMENT.DELETE_ANNOUNCEMENT.CANCEL_BUTTON'), confirmButtonTitle: t('MY_ANNOUNCEMENT.DELETE_ANNOUNCEMENT.CONFIRM_BUTTON'), content: t('MY_ANNOUNCEMENT.DELETE_ANNOUNCEMENT.TEXT'), headerTitle: t('MY_ANNOUNCEMENT.DELETE_ANNOUNCEMENT.TITLE'), onCancel: handleCancel, onConfirm: removeAnnouncement }),
        react_1.default.createElement("h1", null, t('Account.MY_ANNOUNCEMENTS.MY_ANNOUNCEMENTS')),
        loading || (myAnnouncements === null || myAnnouncements === void 0 ? void 0 : myAnnouncements.total) ? (react_1.default.createElement(PostList_1.default, { getPosts: getMyAnnouncementsList, posts: myAnnouncements, layout: PostLayout_1.PostLayout.MY_POSTS, onUpdateToTop: handleUpdateToTop, handleOpenEditPage: function (id) {
                history.push(uri_1.createRoute({
                    path: Routes_1.Routes.EditAnnouncement.path,
                    params: { id: id },
                }));
            }, onRemove: openRemoveAnnouncementModal, 
            // toggleActive={(id, status) => {
            //     handleToggleAnnouncementStatus(id, status);
            // }}
            onStatistic: function (post) {
                showStatistic(post);
            }, previewUrl: GeneralSettings_1.PREVIEW_URL.announcements })) : (react_1.default.createElement("div", { className: "no-result flex-middle" },
            react_1.default.createElement(NoResult_1.default, __assign({}, TYPES))))));
};
exports.default = Announcements;
